import { render, staticRenderFns } from "./ci-credits-table.vue?vue&type=template&id=2fbc6a92&scoped=true&"
import script from "./ci-credits-table.vue?vue&type=script&lang=js&"
export * from "./ci-credits-table.vue?vue&type=script&lang=js&"
import style0 from "./ci-credits-table.vue?vue&type=style&index=0&id=2fbc6a92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbc6a92",
  null
  
)

export default component.exports